import { Button } from 'primereact/button';
import breadcrumbleft from "../../assets/breadcrumbleft.png";
const ModalHeader = ({ onClose, backText }) => {
    return (
      <Button
        link
        onClick={onClose}
        // className="font-semibold text-white-900"
        severity="secondary" outlined 
      >
        <span className="chevronlefticonclass">
          <img src={breadcrumbleft} alt="Back arrow" />
        </span>
        {backText}
      </Button>
    )
}

export default ModalHeader;
